/**
 * Contains common React Context definitions used by the Datapad to avoid prop drilling.
 */

import React from 'react';
import type { AppId } from '../apps/Datapad/AppId';

/**
 * Data used by {@link DatapadAppStateContext}.
 */
export interface DatapadAppStateContextData {
	/**
	 * Update Datapad app state to display the main menu.
	 */
	showMenu(): void;

	/**
	 * Update Datapad app state to display the main menu.
	 */
	hideMenu(): void;

	/**
	 * Change the app selection to the one specified.
	 *
	 * @param selection - The new app selection.
	 * @param urlSearchParams - Optional urlSearch parameters to provide the app.
	 * TODO: encapsulate this better. Apps should not need to know eachothers URL format.
	 * @param toggleMenuState - Optional change to menu state upon changing apps.
	 */
	changeAppSelection(
		selection: AppId,
		urlSearchParams?: string,
		toggleMenuState?: 'open' | 'closed',
	): void;
}

/**
 * React Context containing globally accessible Datapad app state / functionality.
 */
export const DatapadAppStateContext = React.createContext<DatapadAppStateContextData | undefined>(
	undefined,
);
